import type { VendorFormData } from "../types/vendor";

const DEFAULT_ENDPOINT = "vendor/vendor-onboarding";
const baseURL = process.env.REACT_APP_API;
/**
 * Submit vendor data to backend.
 * Throws if the network response is not ok.
 */
export async function submitVendorData(data: VendorFormData): Promise<void> {
  console.log("Submitting vendor data:", data);
  const endpoint = baseURL + DEFAULT_ENDPOINT;
  const resp = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  if (!resp.ok) {
    const text = await resp.text().catch(() => "");
    throw new Error(`Failed to submit vendor data: ${resp.status} ${resp.statusText} ${text}`);
  }else {
    const responseData = await resp.json();
    if(responseData) {
      console.log("Response Data:", responseData);
      if(responseData.response && responseData.response.isDuplicated && responseData.response.isDuplicated === true) {
        console.warn("Duplicate vendor detected:", responseData);
        throw new Error(responseData.message);
      }
    }
  }
}
